import React, { Component, Fragment } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import CustomLoader from '../../../common/CustomLoader';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import * as actions from '../../redux/actions';
import { processData, getFilteredArray, getFieldInfoByName } from './Util';
import CollectionFieldRow from './CollectionFieldRow';
import { filterFieldsOfCollection } from '../../../common/FieldTypes';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import { FieldTypes, pluginCode } from 'drapcode-constant';
//TODO: Refactor
class CollectionUpdateFieldForm extends Component {
  state = {
    params: [],
    isMultiTenantPluginInstalled: false,
  };

  componentDidMount = () => {
    const { eventAction, actionData, events } = this.props;
    const { plugins, collections } = events || '';
    const multiTenantPlugin =
      plugins && plugins.find((e) => e.code === pluginCode.MULTI_TENANT_SAAS);
    const dbParams = eventAction.parameters.find((param) => {
      return param.name === 'collectionUpdateFields';
    });
    let emptyParamsObj = {
      id: 1,
      key: '',
      valueFrom: 'event',
      value: '',
      fieldType: '',
      isMultiSelect: false,
      valueAction: 'DEFAULT',
    };
    let params = [];
    const isFieldEmpty = dbParams && dbParams.value && dbParams.value.length;
    if (isFieldEmpty) {
      emptyParamsObj.id = dbParams.value.length + 1;
      params = [...dbParams.value, emptyParamsObj];
    } else {
      params = [emptyParamsObj];
    }
    this.setState({
      params,
      isMultiTenantPluginInstalled: !!multiTenantPlugin,
    });
  };

  createNewParamRow = (rowObj) => {
    const params = processData(this.state.params, rowObj);
    this.setState({ params });
  };

  closeAllOpenPopup = () => {
    this.props.actions.closeActionFormModal();
    this.props.actions.toggleCreateEvent();
  };

  createActionSettingsSchema = (actionData, eventAction) => {
    let schema = {};
    actionData.args.forEach((args) => {
      const dbParameters = eventAction.parameters.find((param) => {
        return param.name === args.name;
      });
      console.log('dbbbs', dbParameters);
      schema[args.name] = dbParameters ? dbParameters.value : '';
    });
    console.log('createActionSettingsSchema,', schema);
    return schema;
  };

  collectionOptions = () => {
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = this.props.events ? this.props.events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  filterFields = (collectionName) => {
    let collections = this.props.events ? this.props.events.collections : [];
    let selectedCollection = collections.find((e) => e.collectionName === collectionName);
    let selectedFields = filterFieldsOfCollection(selectedCollection, [FieldTypes.large_text.id]);
    return selectedFields;
  };

  derivedFieldsOfCollection = (collectionName) => {
    let collections = this.props.events ? this.props.events.collections : [];
    let selectedCollection = collections.find((e) => e.collectionName === collectionName);
    return selectedCollection ? selectedCollection.utilities : [];
  };

  handleSubmit = (values) => {
    const { actionData, actions, projectId, version, selectedEvent } = this.props;
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });
    parameters.push({
      name: 'collectionUpdateFields',
      value: getFilteredArray(this.state.params),
      type: 'array',
    });

    let actionFormData = this.props.eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    this.props.hideModal();
  };

  updateFindByOptions = () => {
    const { isMultiTenantPluginInstalled } = this.state;
    let options = [
      { value: 'collectionUuid', label: 'Item Id of Collection' },
      { value: 'previousResponse', label: 'Item Id from Previous Step' },
      {
        value: 'currentLoggedInUser',
        label: 'Current LoggedIn User',
      },
    ];
    if (isMultiTenantPluginInstalled) {
      options.push({
        value: 'currentLoggedInUserTenant',
        label: 'Current LoggedIn User Tenant',
      });
    }
    options.push(
      { value: 'SESSION_STORAGE', label: "Browser's Session Storage" },
      {
        value: 'LOCAL_STORAGE',
        label: "Browser's Local Storage",
      },
      {
        value: 'COOKIES',
        label: "Browser's Cookies",
      },
    );
    return options;
  };

  render() {
    const { eventAction, actionData, projectId, version, events } = this.props;
    const { isMultiTenantPluginInstalled } = this.state;
    return (
      <Fragment>
        <Formik
          enableReinitialize={true}
          initialValues={this.createActionSettingsSchema(actionData, eventAction)}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
            <Form>
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Collection"
                      icon="select"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('collection')}
                    >
                      <CustomSelect
                        name={'collection'}
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.collectionOptions()}
                        value={values['collection']}
                        onChangeValue={this.handleChange}
                      />
                      <ErrorMessage name={'collection'}>
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </FormFieldWithLabel>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Update Collection By"
                      icon="select"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('updateFindBy')}
                    >
                      <CustomSelect
                        name={'updateFindBy'}
                        isMulti={false}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={this.updateFindByOptions()}
                        value={values['updateFindBy']}
                        onChangeValue={this.handleChange}
                      />
                    </FormFieldWithLabel>
                  </div>
                </div>
                {[
                  'previousActionResponse',
                  'previousActionFormData',
                  'currentLoggedInUser',
                  'currentLoggedInUserTenant',
                  'SESSION_STORAGE',
                  'LOCAL_STORAGE',
                  'COOKIES',
                ].includes(values['updateFindBy']) && (
                  <Fragment>
                    <div className="col-12">
                      <div className="form-group">
                        <FormFieldWithLabel
                          cta={false}
                          label="Item Id JSON Path"
                          icon="text"
                          infoIcon={true}
                          infoDescription={getFieldInfoByName('updateFindByResponseKeyForValue')}
                        >
                          <Field
                            name="updateFindByResponseKeyForValue"
                            type="text"
                            placeholder={`Item Id JSON Path ${
                              ['currentLoggedInUser', 'currentLoggedInUserTenant'].includes(
                                values['updateFindBy'],
                              )
                                ? ' (Optional)'
                                : ''
                            }`}
                            className="form-control form-control-sm"
                          />
                        </FormFieldWithLabel>
                      </div>
                    </div>
                  </Fragment>
                )}
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Success Message"
                      icon="text"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('successMessage')}
                    >
                      <Field
                        name="successMessage"
                        type="text"
                        placeholder="(Optional) Enter custom success message."
                        className="form-control form-control-sm"
                      />
                    </FormFieldWithLabel>
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Error Message"
                      icon="text"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('errorMessage')}
                    >
                      <Field
                        name="errorMessage"
                        type="text"
                        placeholder="(Optional) Enter custom error message."
                        className="form-control form-control-sm"
                      />
                    </FormFieldWithLabel>
                  </div>
                </div>
                {values['collection'] && (
                  <div className="col-12">
                    <div className="col-12">
                      <label className="text-muted">Fields</label>
                      <CollectionFieldRow
                        createNewParamRow={this.createNewParamRow}
                        params={this.state.params}
                        collectionName={values['collection']}
                        projectId={projectId}
                        fields={this.filterFields(values['collection'])}
                        utilities={this.derivedFieldsOfCollection(values['collection'])}
                        isMultiTenantPluginInstalled={isMultiTenantPluginInstalled}
                        version={version}
                        events={events}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-md-6 text-left">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={this.props.hideModal}
                  >
                    <span>
                      <i className="wb webconnect-times"></i>&nbsp;Cancel
                    </span>
                  </button>
                </div>
                <div className="col-md-6 text-right">
                  <button type="submit" className="btn btn-theme-submit btn-sm">
                    <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                    <CustomLoader loading={this.props.showLoaderForAction} />
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    event: state.event,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionUpdateFieldForm);
